import { postCoreDataSecurityIncidentLogExportSlice } from './post';

export const { requestPostCoreDataSecurityIncidentLogExport, resetPostCoreDataSecurityIncidentLogExport } =
	postCoreDataSecurityIncidentLogExportSlice.asyncActionCreators;
